import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";

export default function useSubscriptionStatus() {
  const user = useRecoilValue(userAtom);
  const subscription = user?.subscription;

  const isSubscribing = subscription?.isSubscribing || false;

  const expirationAt = subscription?.expirationAt;
  const latestPaidAt = subscription?.latestPaidAt;

  const isExpired = !subscription?.isSubscribing && subscription?.hasStarted;

  const isNotStarted =
    !subscription?.isSubscribing && !subscription?.hasStarted;

  const isInAppSubscription =
    subscription?.canceledAt !== null || subscription?.renewedAt !== null;

  const isFirstSubscription =
    isSubscribing && (subscription?.isFirstSubscription || false);

  const hasBeenPlanUpgraded = subscription?.hasBeenPlanUpgraded || false;

  // 일시정지 중 — 서버는 SUBSCRIBING_EXPIRED + isPaused 로 내려준다
  const isPaused = subscription?.isPaused || false;

  return {
    isSubscribing,
    isFirstSubscription,
    isExpired,
    isNotStarted,
    expirationAt, // 구독 만료일. 미래일수도 과거일수도 있음
    latestPaidAt,
    expiryDaysLeft: subscription?.expiryDaysLeft,
    isInAppSubscription,
    bonusDays: subscription?.bonusDays,
    hasBeenPlanUpgraded,
    isPaused,
  };
}
